import { render, staticRenderFns } from "./SocsoGrid.vue?vue&type=template&id=0d50aaae"
import script from "./SocsoGrid.vue?vue&type=script&lang=js"
export * from "./SocsoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports